import { useState, useMemo } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { chakraExtendedTheme } from '@/styles/theme';
import useApiFetch from '@/hooks/useApiFetch';
import useSeoProject from '@/hooks/useSeoProject';
import { FetchApiIds } from '@/types';
import seoContentService from '@/services/seoContent';
import { SeoContentAnalysis } from '@/types/api/seo';
import NewContentAnalysisForm from '@/components/NewContentAnalysisForm';
import SeoContentListComponent from './SeoContentList.component';

const SeoContentListPage = function (): JSX.Element {
  const { project } = useSeoProject();
  const projectId = project?.id ?? '';
  const [isFormOpen, setIsFormOpen] = useState(false);

  const analysesResponse = useApiFetch<{ data: SeoContentAnalysis[] }, void>(
    [FetchApiIds.SEO_CONTENT_ANALYSES, projectId],
    async () =>
      seoContentService.getAll({
        projectId,
        page: 1,
        take: 50,
      }),
    { enabled: !!projectId, retry: false }
  );

  const analyses = useMemo(
    () => (analysesResponse.data as any)?.data ?? [],
    [analysesResponse.data]
  );

  return (
    <>
      <SeoContentListComponent
        analyses={analyses}
        isLoading={analysesResponse.isLoading && !!projectId}
        onNewAnalysis={() => setIsFormOpen(true)}
      />
      <ChakraProvider theme={chakraExtendedTheme}>
        <NewContentAnalysisForm
          open={isFormOpen}
          onClose={() => setIsFormOpen(false)}
          onSubmit={async () => {
            setIsFormOpen(false);
            analysesResponse.refetch();
          }}
        />
      </ChakraProvider>
    </>
  );
};

export default SeoContentListPage;
